<div *ngIf="showValue" class="text-small value">{{ value }} {{ unit }}</div>
<div class="bar bar-container" [title]="value + '%'" [class.bar-radius]="radius">
  <div class="bar bar-progress" [class.bar-radius]="radius" [style.width.%]="value || 0"></div>
</div>
